import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
    Box,
    SvgIcon,
} from '@mui/material';
import colors from 'assets/theme/base/colors';
import rgba from 'assets/theme/function/rgba';
import pxToRem from 'assets/theme/function/px-to-rem';
import { ReactComponent as InfoIcon } from 'assets/images/dialog-icon-close/info.svg';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
    closeConfirmationDialog,
    selectConfirmationDialogOptions,
} from 'store/slices/confirmation-dialog/confirmation-dialog-slice';
import borders from 'assets/theme/base/borders';
import DialogIconClose from 'component/dialog-icon-close';

const ConfirmationDialog: React.FC = () => {
    const { openConfirmationDialog, textInfo, handleConfirm, parameters } =
        useAppSelector(selectConfirmationDialogOptions);
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(closeConfirmationDialog());
    };

    return (
        <Dialog open={openConfirmationDialog ?? false}>
            <Box
                display={'flex'}
                justifyContent={'center'}
                bgcolor={rgba(colors.primary.main, 0.5)}
            >
                <DialogTitle textTransform={'uppercase'}>
                    confirmation
                </DialogTitle>
                <DialogIconClose handleClose={handleClose} />
            </Box>

            <DialogContent>
                <Box
                    pt={pxToRem(30)}
                    pb={pxToRem(50)}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <SvgIcon
                        component={InfoIcon}
                        inheritViewBox
                        sx={{
                            color: colors.common.white,
                            fontSize: {
                                xs: pxToRem(30),
                                md: pxToRem(40),
                            },
                        }}
                    />
                    <Typography
                        sx={{
                            pl: {
                                xs: pxToRem(10),
                                md: pxToRem(15),
                            },
                        }}
                        color={colors.text.secondary}
                        textAlign="center"
                        variant="h3"
                        textTransform={'capitalize'}
                    >
                        {textInfo}
                    </Typography>
                </Box>
                <Divider
                    sx={{
                        borderColor: rgba(colors.action.menu, 1),
                    }}
                />
            </DialogContent>

            <DialogActions
                sx={{
                    paddingTop: pxToRem(30),
                    marginBottom: pxToRem(20),
                    justifyContent: 'center',
                    gap: { xs: pxToRem(10), md: pxToRem(50) },
                }}
            >
                <Button
                    fullWidth
                    size="medium"
                    sx={{
                        borderRadius: borders.borderRadius.md,
                        width: pxToRem(168),
                    }}
                    variant="contained"
                    onClick={() => {
                        handleConfirm(parameters);
                        dispatch(closeConfirmationDialog());
                    }}
                >
                    Yes
                </Button>
                <Button
                    size="medium"
                    sx={{
                        borderRadius: borders.borderRadius.md,
                        width: pxToRem(168),
                        bgcolor: rgba(colors.primary.main, 0.5),
                    }}
                    variant="contained"
                    onClick={() => {
                        dispatch(closeConfirmationDialog());
                    }}
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
